import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface SetFlashMessageResponse extends MiddlewareAPIResponse
{
    
}

export class SetFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements SetFlashMessageResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessageresponse.tsx